<template>
	<div v-show="showFlag">
		<payHeader :bgStatus="bgStatus"></payHeader>
		<div class="user-repwd">
			<div class="container">
				<div class="head">
					<h1>账号申诉</h1>
					<ul>
						<li class="step1 active">验证账号</li>
						<li class="step2 active">实名认证</li>
						<li class="step3 active">申诉资料</li>
						<li class="step4 active">等待审核</li>
					</ul>
				</div>
				<el-result icon="warning" title="请耐心等候等待审核" />
			</div>
		</div>
		<payFooter></payFooter>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { appealStep } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const router = useRouter();
	const showFlag = ref(false);
	
	const appealStepF = () => {
		appealStep().then((res) => {
			if (res.code == 200) {
				switch(res.data.step)
				{
					case 0:
						router.push({ path: '/appeal' })
					break;
					case 1:
						router.push({ path: '/appealAuth' })
					break;
					case 2:
						router.push({ path: '/appealInfo' })
					break;
					case 3:
						showFlag.value = true;
					break;
				}
			}
		})
	}
	
	onMounted(() => {
		appealStepF()
	})

</script>

<style lang="scss" scoped>
	.user-repwd{
		.head h1{background: url(../../assets/images/appeal_icon.png) no-repeat left center;}
	}
</style>